var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid gap-[60px] md:gap-160 grid-cols-1" },
    _vm._l(_vm.projects, function(project, index) {
      return _c("div", { key: project.id, staticClass: "grid grid-cols-12" }, [
        _c(
          "div",
          {
            staticClass: "col-span-12 lg:col-span-6 relative",
            class: {
              "lg:order-1": index % 2 === 0,
              "lg:order-2 lg:col-start-7": index % 2 !== 0
            }
          },
          [
            _vm.showSvg
              ? _c("span", {
                  staticClass:
                    "absolute bottom-[-20px] left-[-30px] lg:bottom-[-40px] lg:left-[-90px] w-[150px] lg:w-[292px]",
                  domProps: { innerHTML: _vm._s(_vm.svg("megaphone-guy-ltr")) }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("project-photo-grid", {
              staticClass: "col-span-6",
              class: {
                "order-1": index % 2 === 0,
                "order-2 col-start-7": index % 2 !== 0
              },
              attrs: { project: project }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-span-12 lg:col-span-5 pt-[40px] md:pt-[100px]",
            class: {
              "lg:order-2 lg:col-start-8": index % 2 === 0,
              "lg:order-1": index % 2 !== 0
            }
          },
          [
            _c("div", { staticClass: "flex flex-wrap gap-8 mb-16" }, [
              _c(
                "span",
                {
                  staticClass:
                    "py-[2.22px] px-[6px] text-white uppercase font-extraBold text-20 bg-black"
                },
                [_vm._v(_vm._s(project.city))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "py-[2.22px] px-[6px] text-white uppercase font-extraBold text-20 bg-black"
                },
                [_vm._v("#nieuwbouw")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "py-[2.22px] px-[6px] text-white uppercase font-extraBold text-20 bg-red"
                },
                [
                  _vm._v(
                    _vm._s(
                      Math.round(parseInt(project.sold_units_percentage))
                    ) + "% verkocht"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "h2",
              {
                staticClass:
                  "mb-24 text-32 lg:text-40 font-extraBold break-hyphens"
              },
              [_vm._v(_vm._s(project.translated_title))]
            ),
            _vm._v(" "),
            _c(
              "v-clamp",
              {
                staticClass: "text-gray-800 font-medium text-20",
                attrs: { autoresize: "", "max-lines": 4, tag: "div" }
              },
              [_vm._v(_vm._s(project.translated_description))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "inline-block mt-32 bg-yellow text-black transition-colors border border-yellow hover:bg-none hover:border-black rounded-8 font-extraBold py-[22px] px-[22px] uppercase text-18",
                attrs: { href: "projecten/" + project.slug }
              },
              [_vm._v("Lees meer")]
            )
          ],
          1
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }